import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../mutation-types';
import courierApi from '../../../api/courier';

const defaultState = () => ({
    courier: [],
    selectedCourier: []
});

const state = defaultState();

const getter = {};

const mutations = {
    listCourier(state, data, ) {
        state.courier = data;
    },
    selectCourier(state, data, ) {
        state.selectedCourier = Object.assign([], state.selectedCourier, data);
    },
};

const actions = {
    getCourier({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        courierApi.getDataCourier().then(({ data: { data } }) => {
            commit('listCourier', data.results);
            let selectCour = []
            data.results.forEach(cour => {
                if (cour.selected == '1') {
                    selectCour.push(cour)
                }
            });
            commit('selectCourier', selectCour);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    updateCourier({ state, commit, dispatch }) {
        let selectCour = { courier: '' }
        commit(PROGRESS_START, null, { root: true });
        selectCour.courier = state.selectedCourier

        courierApi.updateCourier(selectCour).then(() => {
            commit(PROGRESS_FINISH, null, { root: true });
            dispatch('getCourier');
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
        });
    },
};

export default {
    namespaced: true,
    state,
    getter,
    mutations,
    actions,
}